import styled from "styled-components";

export const StyledVariantOptionListItemWrapper = styled.div`
  background-color: #ffffff;
  padding: 1.2rem;
  border-radius: 8px;
`;
